export default {
  from: {
    index: 'Home',
    service: 'Our Services',
    about: 'About us',
    putai: 'Protac Design Platform',
    contact: 'Contact Us',
    title: 'Welcome to use Hong Kong Putai Medical Technology. We are your preferred choice for designing Putai',
    more: 'Learn more',
    changeLanguage: 'English',
    partners: 'Our Advantages',
    sales: 'Regarding after-sales service',
    salesText: 'Technology one-on-one communication, responsible throughout the process. Assist clients in defending or revising their papers or responding to review comments. The beginning of after-sales service is the beginning of our entire project.',
    process: 'Regarding the process',
    processText: 'Efficient work, full day service, able to complete project calculations in a short period of time according to customer requirements, regularly reflect on calculation progress, and have accurate and predictive data results.',
    report: 'Regarding the report',
    reportText: 'SCI level graphic and text report, available in both Chinese and English.',
    product: 'Our Products',
    product01: 'PT 36-3090 server (4U)',
    product02: 'PT 36-3090 server (2U)',
    product03: 'Multi card node server',
    product04: 'PT Gen 2 server',
    product05: 'CPU',
    product06: 'memory',
    product07: 'Network card/RAID card/HBA card',
    product08: 'hard disk',
    product09: 'PT Storage SL2000 Series',
    product10: 'PT Storage SL5000 Series',
    product11: 'PT Storage SL9900 Series',
    product12: 'PT Switch',
    product13: '10 Gigabit switch',
    product14: 'Wireless network devices',
    product15: 'outer',
    product16: 'system integration',
    product17: 'Single machine workstation for full tower multi card molecular dynamics simulation',
    product18: 'Multi Core Computational Chemistry Standalone Workstation',
    product19: 'RTX3080TI Molecular Dynamics Simulation GPU',
    product20: 'RTX4090 Molecular Dynamics Simulation GPU',
    product21: 'Tesla Machine Learning GPU',
    tab01: 'Rack server',
    tab02: 'Server accessories',
    tab03: 'storage',
    tab04: 'National production server',
    tab05: 'workstation',
    tab06: 'GPU server',
    all: 'All',
    case: 'Our Case',
    company: 'Hong kong Putai Medical Technology',
    company1: '"High-Performance Workstation Customization',
    company2: '1.Molecular Simulation Computing Environment Setup',
    company3: '2.Pre-installed Common Molecular Simulation Software',
    company4: '3.Two-year Warranty, Service Response Within 3 Hours"',
    newProduct: 'PRODUCT',
    illustrate: 'DESCRIPTION',
    supplier: 'Solutions for Molecular Simulation In Medical Industry',
    design: 'Online Platform For PROTACs Design',
    service01: 'Customized theoretical calculation solutions',
    service02: 'Get free quotes for simulation computing solutions',
    service03: '500+certified engineers · 1 on 1 communication to develop solutions · Ensure data authenticity and repeatability',
    spec: 'Product specifications',
    aboutUs01: '"We are an innovative technology service company composed of several PhDs, with team members having many years of professional experience in drug development, molecular simulation, and the field of artificial intelligence.',
    aboutUs02: 'We approach our work with a professional attitude, crafting applicable solutions, and are dedicated to becoming an outstanding service provider in the molecular simulation technology industry. Shu Li Technology possesses a complete technical service system, ranging from molecular simulation research to chemical synthesis and activity testing."'
  },
  dr: {
    Founder: 'Founder',
    Partner: 'Partner organization',
    Interests: 'Interests',
    name01: 'Dr. DAI Liang',
    name02: 'Mr. Liang SUN',
    name03: 'Dr. Wen XIONG',
    name04: 'Mr. Xinyu LI',
    name05: 'Mr. Jialu CHEN',
    conetent01: 'Calculate soft matter',
    conetent02: 'Biophysics',
    conetent03: 'Polymer Physics',
    introduce01: 'Assistant Professor (City University) Advisor',
    introduce02: 'Director of Doctoral Student (City University)',
    introduce03: 'PostDoc. post file. (Billion cubic meters) Responsible for developing in vitro/in vivo enhancement platforms',
    introduce04: 'PhD student (CUHK) responsible for molecular simulation and PROTAC molecular design',
    introduce05: 'PhD student (City University) responsible for AI technology',
  },
  partner: {
    title: 'Our Partners',
    school01: 'Qingdao bioenergy Research Institute, Chinese Academy of Sciences',
    school02: 'Shenyang Institute of Applied Chemistry, Chinese Academy of Sciences',
    school03: 'Research Center for Ecological and Environmental Sciences, Chinese Academy of Sciences',
    school04: 'Institute of Forestry Chemical Industry, Chinese Academy of Forestry Sciences',
    school05: 'Chengdu Yuanshu Technology Co., Ltd',
    school06: 'Sichuan University',
    school07: 'University of Hong Kong',
    school08: 'Zhejiang University',
    school09: 'Lanzhou University',
    school10: 'Chengdu Shuyuan Technology Co., Ltd',
    school11: 'Tongji University',
    school12: 'Hainan University',
    school13: 'Shandong University',
    school14: 'Jiangsu University',
    school15: 'Waiting for nearly a hundred organizations and universities',
    school16: 'Southwest University',
    school17: 'Jinan University',
    school18: 'Xiangya Third Hospital of Central South University',
    school19: 'Shenzhen Shuli Technology Co., Ltd',
  },
  product: {
    indexP101: 'As a mainstream 2U two way rack server independently developed, H3C UniServer R4900 G5 is based on the new generation Intel ® xeon  ® Scalable processors can achieve up to 52% processor floating-point performance improvement and 42% increase in core count, combined with 8-channel 3200MT/s DDR4 memory technology, providing users with up to 60% bandwidth improvement.',
    indexP201: 'Achieve excellent scalability through local storage support of up to 14 standard PCIe 4.0 slots and up to 41 hard drive slots. 96% power efficiency and a standard operating temperature design of 5 ℃ -45 ℃ provide users with higher energy efficiency returns.',
    subTitle01: 'Dual Rack Server for Universal Computing',
    indexP102: 'As a mainstream 2U two way rack server independently developed, H3C UniServer R4900 G3 is based on the new generation of Intel ® xeon  ® Scalable family processors can achieve up to 71% performance improvement and 27% increase in core count, combined with 6-channel 2933MT/s DDR4 memory technology, providing users with up to 50% performance improvement.',
    indexP202: 'Achieve excellent scalability through local storage support of up to 10 PCIe 3.0 slots 1 and up to 40 hard drive slots 1. Optional configuration of security intelligent protection module, providing comprehensive personal protection for critical business. 96% power efficiency and a standard operating temperature design of 5 ℃ -50 ℃ provide users with higher energy efficiency returns.',
    subTitle02: 'Dual Rack Server for Universal Computing',
    indexP103: 'The HPE ProLiant DL380 Gen10 server is designed to effectively reduce costs and complexity. Second generation Intel ® xeon  ® Scalable processor, with a performance improvement of up to 60% and a 27% increase in core count, while supporting up to 3TB of HPE DDR4 2933 MT/s intelligent memory, with a performance improvement of up to 82%.',
    indexP203: 'The server supports 12Gb/s SAS interfaces, up to 20 NVMe hard drives, and a wide range of computing options. HPE NVDIMM and DC permanent memory provide better performance advantages for the analysis load of databases, suitable for any workload from basic applications to critical business, and easy to deploy.',
    subTitle03: 'High performance universal rack server for multi load computing',
    indexP104: 'The HPE ProLiant DL580 Gen10 server uses a 4U chassis and is a secure, highly scalable four way server with high performance, scalability, and availability. HPE ProLiant DL580 Gen10 server supports second-generation Intel ® xeon  ® Scalable processors provide significantly higher processing power than previous generations, with up to sixteen PCIe 3.0 slots, coupled with the simple automation management brought by HPE OneView and HPE iLO 5.',
    indexP204: 'The HPE ProLiant DL580 Gen10 server is highly suitable for business critical workloads and general 4P data-intensive applications that prioritize performance.',
    subTitle04: 'Highly scalable enterprise level four way rack servers for critical business',
    subTitle09: 'As a new generation SAN product, H3C UniStor CF2000 storage product supports 12-128GB device cache, can provide up to 200000 IOPS and market price of entry-level products, and can provide affordable application acceleration solutions for customers.',
    subTitle10: 'The full flash configuration of the H3C CF storage system starts at only $19000',
    subTitle11: 'X10000 supports x86 architecture and ARM architecture CPUs',
    column01: 'Code',
    column02: 'product code',
    column03: 'describe',
  },
  footer: {
    title: "Contact Us",
    phone: 'Call us',
    email: 'Email',
    address: 'address',
    location: 'Unit C, 21st Floor, Monterey Plaza, 15 Chong Yip Street, Kwun Tong, Kowloon, Hong Kong Special Administrative Region',
    wx: 'Scan code to add customer service WeChat',
    gzh: 'Scan the QR code to follow the WeChat official account of Magic Technology and obtain the latest molecular simulation information',
    pre1: 'Previous article:',
    pre2: 'Previous product',
    next1: 'Next article:',
    next2: 'Next product',
    no: 'No more'
  },
  language: {
    Chinese: '中文(繁)',
    English: 'English',
  }
}
